export const statusMap: Record<string, { label: string; color: string; dot: string }[]> = {
  dispatched: [ { label: 'Dispatched', color: 'bg-emerald-50 text-emerald-700 ring-emerald-200', dot: 'bg-emerald-500' } ],
  new:        [ { label: 'New', color: 'bg-amber-50 text-amber-700 ring-amber-200', dot: 'bg-amber-500' } ],
  // processing: [ { label: 'Processing', color: 'bg-blue-50 text-blue-700 ring-blue-200', dot: 'bg-blue-500' } ],
  // shipped:    [ { label: 'Shipped', color: 'bg-indigo-50 text-indigo-700 ring-indigo-200', dot: 'bg-indigo-500' } ],
  // completed:  [ { label: 'Completed', color: 'bg-slate-50 text-slate-700 ring-slate-200', dot: 'bg-slate-500' } ],
  // refunded:   [ { label: 'Refunded', color: 'bg-rose-50 text-rose-700 ring-rose-200', dot: 'bg-rose-500' } ],
  // cancelled:  [ { label: 'Cancelled', color: 'bg-neutral-100 text-neutral-700 ring-neutral-300', dot: 'bg-neutral-500' } ]
}

export const StatusPill: any = ( { status }: { status: keyof typeof statusMap } ): any => {
  const s = statusMap[ status ][ 0 ]

  return (
    <span
      className={ `inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset ${ s.color }` }
    >
      <span className={ `h-1.5 w-1.5 rounded-full ${ s.dot }` } />
      { s.label }
    </span>
  )
}
